import {entrepreneursThatStartedExportOrImport} from './common/entrepreneurs-that-started-export-or-import';

/**
 * Survey: PROJECT- BASELINE IMPACT
 * Question: Is your company currently engaged in exporting?
 * 
 * == baseline
 * export_t0
 * 
 * Survey: PROJECT - FINAL IMPACT
 * Question: Is your company currently engaged in exporting?
 * 
 * == final
 * export_t1
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursThatStartedExportTotalCalculation = (props: any) => {
    return entrepreneursThatStartedExportOrImport(props, 'export_t0', 'export_t1', 'NO');
}